export default {
  setProdutos(state, payload) {
    state.produtos = payload;
  },
};
